import type { TiendaBaseConfigDTO, TiendaContenidoDTO, TiendaEstiloDTO } from "../templates/types";
import { HttpAxiosRequest } from ".";

export interface TemplateActivoDTO {
    vchTemplateId: string;
    dtmFechaModEstilo: string;
    dtmFechaModContenido: string;
}

export class TiendaNoEncontradaError extends Error {
    constructor() {
        super("No se encontró ninguna tienda asociada a este dominio.");
        this.name = "TiendaNoEncontradaError";
    }
}

function esNotFound(error: unknown): boolean {
    const status = (error as { cause?: { response?: { status?: number } } })?.cause?.response
        ?.status;
    return status === 404;
}

function ignorarSalvoNotFound<T>(error: unknown): T | null {
    if (esNotFound(error)) throw new TiendaNoEncontradaError();
    return null;
}

export const HttpTiendaTemplate = {
    getActivo: (): Promise<TemplateActivoDTO | null> =>
        HttpAxiosRequest.get<TemplateActivoDTO>("/tienda/template/activo").catch(() => null),

    getEstilo: (): Promise<TiendaEstiloDTO | null> =>
        HttpAxiosRequest.get<TiendaEstiloDTO>("/tienda/template/estilo").catch(
            ignorarSalvoNotFound<TiendaEstiloDTO>,
        ),

    getContenido: (): Promise<TiendaContenidoDTO | null> =>
        HttpAxiosRequest.get<TiendaContenidoDTO>("/tienda/template/contenido").catch(
            ignorarSalvoNotFound<TiendaContenidoDTO>,
        ),

    getTemplateBase: async (vchTemplateId: string): Promise<TiendaBaseConfigDTO | null> => {
        const res = await HttpAxiosRequest.get<{
            estilo: TiendaEstiloDTO;
            contenido: TiendaContenidoDTO;
        }>(`/tienda/template/base/${vchTemplateId}`).catch(() => null);
        if (!res) return null;
        return { ...res.estilo, ...res.contenido, bitActiva: true };
    },
};
